export enum GroupedValuePathsEnum {
  actionWeight = 'actionWeight',
  bucketsOrderSortType = 'bucketsOrderSortType',
  showFilters = 'showFilters',
  showSort = 'showSort',
}

export enum ValuePathByGroupName {
  weight = GroupedValuePathsEnum.actionWeight,
  action = GroupedValuePathsEnum.actionWeight,
  'bucketsOrder.sort' = GroupedValuePathsEnum.bucketsOrderSortType,
  'bucketsOrder.type' = GroupedValuePathsEnum.bucketsOrderSortType,
  enableMobileFilters = GroupedValuePathsEnum.showFilters,
  enableDesktopFilters = GroupedValuePathsEnum.showFilters,
  enableMobileSort = GroupedValuePathsEnum.showSort,
  enableDesktopSort = GroupedValuePathsEnum.showSort,
}

export enum DiffActionType {
  Created = 'created',
  Changed = 'changed',
  Deleted = 'deleted',
}

export enum PreviewTypeEnum {
  REVIEW_BEFORE_PUBLISH = 'REVIEW_BEFORE_PUBLISH',
  REVIEW_VERSION = 'REVIEW_VERSION',
  COMPARE_VARIANT = 'COMPARE_VARIANT',
}
